export default __webpack_public_path__ + "static/media/creative-footer-circles.87c4e903.svg";